module.exports = __webpack_public_path__ + "static/modedemploi-61c2ff20c66f259dad7b104390ae14f7.pdf";